import eventsSlideshow from './eventsSlideshow';

export default function specialEvents() {
  const widgetName = 'specialEvents';
  const { currentWidgetModuleItemID, scriptPath } = specialEventsOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID,
    scriptPath,
    maxItemsVisible: 10,
    itemsPerPanel: 10,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomBtnEvents($widget, data.items);
      } else {
        $('.special-events-container').remove();
      }
    },
  });
}

function createCustomBtnEvents($widget, widgetData) {
  const $dropdownContainer = buildDropdown($widget);
  const $dropdownSelected = $dropdownContainer.find('.dropdown-selected');
  const $dropdownList = $dropdownContainer.find('.dropdown-list');

  $widget
    .find('.card-widget-item')
    .attr({ role: 'tab', 'aria-controls': 'eventsSlideshow' })
    .wrapAll('<div class="events-buttons" role="tablist"></div>');

  const today = new Date().setHours(0, 0, 0, 0);
  const listItems = [];
  let firstAvailableEvent = null;

  widgetData.forEach((data, index) => {
    const $card = $widget.find('.card-widget-item').eq(index);
    if (!$card.length) return;

    const result = processCard($card, data, today);

    if (!result.isPast) {
      bindItemEvents($card, $widget);
      if (!firstAvailableEvent) {
        firstAvailableEvent = result.title;
      }
    }

    listItems.push(result.$li);
  });

  $dropdownList.append(listItems);
  bindDropdownEvents($dropdownSelected, $dropdownList, $widget);

  if (firstAvailableEvent) {
    activateEvent(firstAvailableEvent, $widget);
  } else {
    $('.special-events-container').remove();
  }
}

function buildDropdown($widget) {
  const $container = $('<div class="dropdown-container"></div>');
  $container.append('<div class="dropdown-selected" tabindex="0">Select event date</div>');
  $container.append('<ul class="dropdown-list closed"></ul>');

  $widget.append($container);
  return $container;
}

function processCard($card, data, today) {
  const { DateRange, Title, Description, DetailLinkText } = data;

  const startDateString = DateRange ? DateRange.split('-')[0] : Description.split('-')[0];
  const dateLayout = new Date(startDateString.trim()).setHours(0, 0, 0, 0);

  const isPast = dateLayout < today;
  const headline = DateRange ? Description : DetailLinkText;

  const USLocale = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'short' });
  const formattedDate = USLocale.format(dateLayout);
  const accessibleDate = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'long' }).format(
    dateLayout,
  );

  $card.attr({
    'data-event-title': Title,
    'data-event-headline': headline,
  });

  $card.find('.card-content').replaceWith(`
    <div class="block-date" role="tablist" aria-label="${accessibleDate}">
      <span class="date-event">${formattedDate}</span>
    </div>
  `);

  if (isPast) {
    $card.addClass('past-event').attr('hidden', 'true');
  } else {
    $card.attr('tabindex', '0');
  }

  const $li = $(
    `<li data-title="${headline}" data-event-title="${Title}" ${isPast ? 'class="disabled"' : ''}>${formattedDate}</li>`,
  );

  return { $li, title: Title, headline, isPast };
}

function bindDropdownEvents($selected, $list, $widget) {
  $selected.on('click', function (e) {
    e.stopPropagation();
    $list.toggleClass('closed');
    $list.show();
    $list.focus();

    const isClosed = $list.hasClass('closed');
    $list.attr('tabindex', isClosed ? '-1' : '0');

    if (!isClosed) {
      $list.find('li:not(.disabled)').attr('tabindex', '0');
    }
  });

  $selected.on('keydown', function (e) {
    if (['Enter', ' ', 'ArrowDown'].includes(e.key)) {
      e.preventDefault();
      $list.removeClass('closed');
      $list.find('li:not(.disabled)').attr('tabindex', '0');
      $list.show();
      $list.find('li:not(.disabled)').first().focus();
    }
  });

  $list.on('click', 'li', function () {
    const $li = $(this);
    if ($li.hasClass('disabled')) return;

    activateEvent($li.data('event-title'), $widget);

    $list.addClass('closed');
    $list.hide();
    $selected.focus();
  });

  $list.on('keydown', 'li', function (e) {
    const $current = $(this);

    switch (e.key) {
      case 'Enter':
      case ' ':
        e.preventDefault();
        $list.hide();
        $current.trigger('click');
        break;

      case 'ArrowDown':
        e.preventDefault();
        $current.nextAll('li:not(.disabled)').first().focus();
        break;

      case 'ArrowUp': {
        e.preventDefault();
        const $prev = $current.prevAll('li:not(.disabled)').first();
        if ($prev.length) $prev.focus();
        else $selected.focus();
        break;
      }

      case 'Escape':
        $list.addClass('closed');
        $list.find('li:not(.disabled)').removeAttr('tabindex');
        $list.hide();
        $selected.focus();
        break;
    }
  });

  $(document).on('click', () => {
    $list.find('li:not(.disabled)').removeAttr('tabindex');
    $list.hide();
    $list.addClass('closed');
  });
}

async function activateEvent(eventTitle, $widget) {
  const $target = $widget.find(`.card-widget-item[data-event-title="${eventTitle}"]`);
  if (!$target.length) return;

  const headline = $target.data('event-headline');
  const formattedDate = $target.find('.date-event').text();

  $widget.find('.card-widget-item').attr('aria-selected', 'false').removeClass('selected');
  $target.addClass('selected').attr('aria-selected', 'true');
  $widget.find('.dropdown-selected').text(formattedDate);

  await eventsSlideshow(eventTitle);
  headlineTransition(headline);
}

function bindItemEvents($item, $widget) {
  $item.on('click', function () {
    const $current = $(this);
    if ($current.hasClass('selected')) return;

    activateEvent($current.data('event-title'), $widget);
  });

  $item.on('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $(this).trigger('click');
    }
  });
}

function headlineTransition(headline) {
  const $headline = $('#eventsSlideshow .headline-desktop');

  if (headline.length) {
    $headline.css('opacity', '0');
    setTimeout(() => {
      $headline.text(headline).css('opacity', '1');
    }, 300);
  } else {
    $headline.css('display', 'none');
  }
}
